
import PropTypes from 'prop-types'
import { Page } from 'frame/components'

const PageNotFound = ({ title }) => {
  return (
    <Page
      sx={{
        padding: 3
      }}
      title={title}>
      <h1>{title}</h1>
    </Page>
  )
}

PageNotFound.propTypes = {
  title: PropTypes.string.isRequired,
}

export default PageNotFound
